import Button from 'components/form/Button';
import SeachInput from 'components/form/SeachInput';
import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { icons } from 'utils/constants';
import AddManualFollowUpPopup from '../AddManualFollowUpPopup';
import CheckBox from 'components/form/CheckBox';
import Profile from 'components/Layout/Profile';
import { Accordion, Pagination } from 'react-bootstrap';
import './ManualFollowUpData.scss';
import FollowUpUserDetails from '../FollowUpUserDetails';
import { fetchFollowupsAlert, fetchFollowupsList } from 'store/slices';

const ManualFollowUpData = () => {
  const [followUpsList, setFollowUpsList] = useState([]);
  const dispatch = useDispatch();
  const params = useParams();
  const { eID } = params;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const [isopenManualFollowupPopup, setIsopenManualFollowupPopup] =
    useState(false);

  const [searchPayload, setSearchPayload] = useState({ search: '' });

  const [data, setData] = useState([]);
  const [eventName, setEventName] = useState('');
  const fetchFollowupsAlertData = async () => {
    const payload = {
      id: eID,
      type: 'event',
    };
    const response = await dispatch(fetchFollowupsAlert(payload));
    if (response.status === 200) {
      setData(response?.data?.followups_data);
      setEventName(response?.data?.event_name);
    }
  };

  useEffect(() => {
    fetchFollowupsAlertData();
  }, []);

  const transformedData = Object.entries(data || {}).map(
    ([stageName, details]) => {
      const sessions = Object.values(details).filter(
        (item) => typeof item === 'object' && item.id
      ); // Only real sessions
      return {
        stage: stageName,
        created_at: details.created_at || '',
        sessions,
      };
    }
  );

  const fetchFollowupsData = async () => {
    const response = await dispatch(fetchFollowupsList());
    if (response.status === 200) {
      const formattedData = response.data.followups_list.map(
        (label, index) => ({
          id: index + 1,
          label: label,
        })
      );
      setFollowUpsList(formattedData);
    }
  };

  useEffect(() => {
    fetchFollowupsData();
  }, []);

  const getStageIdByLabel = (stage, labelList) => {
    const found = labelList.find((item) => item.label === stage);
    return found ? found.id : null; 
  };

  return (
    <>
      {/* <Card className="d-flex align-items-center p-2 unset-br mb-3">
        <div className="d-flex align-items-center flex-wrap gap-2">
          <div
            className={tabType === '0' ? activeClass : inActiveClass}
            onClick={() => {
              setTabType('0');
            }}
          >
            Unpaid
          </div>
          <div
            className={tabType === '1' ? activeClass : inActiveClass}
            onClick={() => {
              setTabType('1');
            }}
          >
            Paid
          </div>
        </div>
      </Card> */}
      <div id="follow-up-detail-container">
        <Card className="cpt-34 cpe-20 cps-20 cpb-34 h-100">
          <div className="d-flex align-items-center justify-content-between  cpb-15 border-bottom">
            <div className="d-flex align-items-center gap-3">
              <img
                src={icons.leftArrow}
                alt="back"
                className="h-21 pointer"
                onClick={() => {
                  navigate(-1);
                }}
              />
              <div className="table-title">Follow-up (0)</div>
            </div>
            <div className="d-flex align-items-center flex-wrap gap-3">
              <div style={{ width: '220px' }}>
                <SeachInput
                  placeholder="Search"
                  value={''}
                  onChange={() => {}}
                  onKeyDown={() => {}}
                  onClick={() => {}}
                  isSearchPointer
                />
              </div>
              {true && (
                <Button
                  onClick={() => {
                    setIsopenManualFollowupPopup(true);
                  }}
                  text="+ Add Follow-Up"
                  btnStyle="primary-outline"
                  className="h-35 text-14-500 w-auto px-3"
                  isSquare
                />
              )}
            </div>
          </div>

          <div className="cmb-16 text-16-400-27 color-black-olive cpt-20">
            {eventName}
          </div>

          {isLoading ? (
            <div className="center-flex cpt-50 cpb-50">
              <Loader size="md" />
            </div>
          ) : transformedData?.length > 0 ? (
            <>
              <div className="row">
                {transformedData.map((item, index) => (
                  <div
                    className="col-md-6 col-lg-6 col-xl-6 cmb-14"
                    key={index}
                  >
                    <div className="cps-19 cpt-16 cpe-19 cpb-14 follow-up-detail-border gap-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <div>{item.stage}</div>
                          <div className="text-12-400-15 cpt-8">
                            {item.created_at}
                          </div>
                        </div>

                        <div>
                          <Button
                            text="+ Add Follow-Up"
                            btnStyle="primary-outline"
                            className="h-35 text-14-500 w-auto px-3 btn-round-premium"
                            isSquare
                          />

                          <div className="d-flex cpt-6 justify-content-start align-items-center gap-2">
                            <img
                              src={icons.circleInfo}
                              alt="info"
                              className="h-14 w-14"
                            />
                            <div className="text-12-400-15">
                              {'Info text here'}
                            </div>
                          </div>
                        </div>
                      </div>

                      <Accordion className="cpt-12">
                        {item.sessions.map(
                          (session, idx) => (
                            {/* console.log('✌️session --->', session), */}
                            (
                              <Accordion.Item
                                eventKey={idx.toString()}
                                key={session.id}
                              >
                                <Accordion.Header>
                                  <div className="d-flex justify-content-between w-100 text-14-400-18">
                                    <span>{`${String.fromCharCode(65 + idx)}) ${
                                      session.stage
                                    }`}</span>
                                    <span className="text-muted cpe-10">
                                      {session.created_at}
                                    </span>
                                  </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                  <div className="p-3">
                                    <div className="d-flex justify-content-between gap-4 text-14-500-18 mb-2 cpb-5">
                                      <span className="color-a35b">
                                        Sent : <strong>{session.sent}</strong>
                                      </span>
                                      <span className="color-4646">
                                        Failed :{' '}
                                        <strong>{session.failed}</strong>
                                      </span>
                                      <span className="color-E751">
                                        Pending :{' '}
                                        <strong>{session.pending}</strong>
                                      </span>
                                    </div>

                                    <hr className="cpb-5" />

                                    <div className="d-flex justify-content-between text-14-500-18 cmb-20">
                                      <span>
                                        Total Users :{' '}
                                        <strong>
                                          {session.sent +
                                            session.failed +
                                            session.pending}
                                        </strong>
                                      </span>
                                      <span>
                                        Paid : <strong>{session.paid}</strong>
                                      </span>
                                    </div>

                                    <Button
                                      text="View Details"
                                      btnStyle="primary-dark"
                                      className="h-35 text-14-500 w-auto px-4 btn-round-premium"
                                      isSquare
                                      onClick={() => {
                                        navigate(
                                          `/admin/follow-up-discount/${eID}/manual-follow-up/${getStageIdByLabel(
                                            session?.stage,
                                            followUpsList
                                          )}/followup-users`
                                        );
                                      }}
                                    />
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            )
                          )
                        )}
                      </Accordion>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="row">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="text-center cmt-100">
                  <img
                    src={icons.circleInfo}
                    alt="No Data"
                    className="h-60 w-60"
                  />
                  <h3 className="cmt-22 text-32-500-40">Follow-Up Not Found</h3>
                  {true && (
                    <div className="cmt-22 d-flex align-items-center justify-content-center">
                      <Button
                        text="+ Add Follow-Up"
                        btnStyle="primary-outline"
                        className="h-35 text-14-500 w-auto px-3"
                        onClick={() => setIsopenManualFollowupPopup(true)}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </Card>
      </div>

      {isopenManualFollowupPopup && (
        <AddManualFollowUpPopup
          onHide={() => setIsopenManualFollowupPopup(false)}
          event_id={eID}
          followUpsList={followUpsList}
        />
      )}
    </>
  );
};

export default ManualFollowUpData;
